/*
═══════════════════════════════════════════════════════════
НАСТРОЙКА НА ЯСНОСТЬ / CLARITY — Экран дня
═══════════════════════════════════════════════════════════
Автор: @Elena_evolvecode
Telegram: @na_sh_kodila
Создано: 2025-2026
Все права защищены
═══════════════════════════════════════════════════════════
*/

import React from 'react';
import InjectionCard from './InjectionCard';
import TaskCard from './TaskCard';

const DayScreen = ({
  dayData,
  dayProgress,
  onL1Increment,
  onL2Toggle,
  onInjectionRead,
  isDayComplete,
  hideProgressBar = false,
}) => {
  if (!dayData || !dayProgress) {
    return null;
  }

  const taskBody = dayData.tasks?.body || { name: '', action: '', examples: [], metric_label: '' };
  const taskSpeech = dayData.tasks?.speech || { name: '', action: '', examples: [], metric_label: '' };

  return (
    <div style={styles.container}>
      {isDayComplete && (
        <div style={styles.completeBadge}>
          <span style={styles.completeBadgeIcon}>✓</span>
          <span style={styles.completeBadgeText}>День завершён</span>
        </div>
      )}

      <InjectionCard
        tuning={dayData.tuning}
        isRead={dayProgress.injectionRead}
        onRead={onInjectionRead}
      />

      <div style={styles.tasksContainer}>
        <TaskCard
          type="body"
          task={taskBody}
          count={dayProgress.l1Count}
          isCompleted={dayProgress.l1Count > 0}
          onAction={onL1Increment}
        />

        <TaskCard
          type="speech"
          task={taskSpeech}
          count={0}
          isCompleted={dayProgress.l2Completed}
          onAction={onL2Toggle}
        />
      </div>

      {!hideProgressBar && (
        <div style={styles.progressSection}>
          <div style={styles.progressHeader}>
            <span style={styles.progressLabel}>Прогресс дня</span>
            <span style={styles.progressCount}>
              {[dayProgress.injectionRead, dayProgress.l1Count > 0, dayProgress.l2Completed].filter(Boolean).length}/3
            </span>
          </div>
          <div style={styles.progressBar}>
            <div
              style={{
                ...styles.progressFill,
                width: `${([dayProgress.injectionRead, dayProgress.l1Count > 0, dayProgress.l2Completed].filter(Boolean).length / 3) * 100}%`,
              }}
            />
          </div>
          <div style={styles.progressItems}>
            <div style={styles.progressItem}>
              <span style={{
                ...styles.progressDot,
                ...(dayProgress.injectionRead ? styles.progressDotComplete : {}),
              }}>
                {dayProgress.injectionRead ? '✓' : ''}
              </span>
              <span style={styles.progressItemText}>Настройка</span>
            </div>
            <div style={styles.progressItem}>
              <span style={{
                ...styles.progressDot,
                ...(dayProgress.l1Count > 0 ? styles.progressDotComplete : {}),
              }}>
                {dayProgress.l1Count > 0 ? '✓' : ''}
              </span>
              <span style={styles.progressItemText}>Тело</span>
            </div>
            <div style={styles.progressItem}>
              <span style={{
                ...styles.progressDot,
                ...(dayProgress.l2Completed ? styles.progressDotComplete : {}),
              }}>
                {dayProgress.l2Completed ? '✓' : ''}
              </span>
              <span style={styles.progressItemText}>Речь</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  completeBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '12px 20px',
    background: 'rgba(229, 210, 160, 0.15)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(229, 210, 160, 0.4)',
    borderRadius: '12px',
  },
  completeBadgeIcon: {
    color: '#E5D2A0',
    fontSize: '16px',
  },
  completeBadgeText: {
    color: '#E5D2A0',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '1px',
  },
  tasksContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  progressSection: {
    marginTop: '8px',
    padding: '20px',
    background: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '16px',
  },
  progressHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  progressLabel: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: '13px',
  },
  progressCount: {
    color: '#E5D2A0',
    fontSize: '13px',
    fontWeight: '600',
  },
  progressBar: {
    height: '4px',
    background: 'rgba(229, 210, 160, 0.2)',
    borderRadius: '2px',
    overflow: 'hidden',
    marginBottom: '16px',
  },
  progressFill: {
    height: '100%',
    background: '#E5D2A0',
    borderRadius: '2px',
    transition: 'width 0.3s ease',
  },
  progressItems: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  progressItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
  },
  progressDot: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'rgba(229, 210, 160, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    color: '#E5D2A0',
  },
  progressDotComplete: {
    background: 'rgba(229, 210, 160, 0.2)',
    borderColor: '#E5D2A0',
  },
  progressItemText: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: '11px',
  },
};

export default DayScreen;
